module.exports = __webpack_public_path__ + "images/Card287fa45b04e8cc2682aea2a3a5aecbf95.png";